var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.182,
    height: 34,
    viewBox: "0 0 108.182 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{clip-path:url(#a);}.d{fill:url(#b);}.e{clip-path:url(#c);}.f{fill:url(#d);}.g{clip-path:url(#e);}.h{fill:url(#f);}.i{clip-path:url(#g);}.j{fill:url(#h);}.k{clip-path:url(#i);}.l{fill:url(#j);}.m{clip-path:url(#k);}.n{fill:url(#l);}.o{clip-path:url(#m);}.p{fill:url(#n);}.q{clip-path:url(#o);}.r{fill:url(#p);}.s{clip-path:url(#q);}.t{fill:url(#r);}.u{fill:#404040;}.v{clip-path:url(#s);}.w{fill:url(#t);}.x{clip-path:url(#u);}.y{fill:url(#v);}.z{clip-path:url(#w);}.aa{fill:url(#x);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.061-36.987,27-37.043a1.562,1.562,0,0,1-.371-1.108v.115h0V-55.353a1.509,1.509,0,0,1,.429-1.165l9.929,9.766-9.928,9.765m-.43-18.486c0-.043,0-.086,0-.127,0,.041,0,.084,0,.127m0-.129a0,0,0,0,1,0,0,0,0,0,0,0,0,0m0-.006h0",
    transform: "translate(-26.63 56.518)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1.545,
    y1: 1.711,
    x2: -1.537,
    y2: 1.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.173-38.878h0l.075-.042,3.921-2.191a1.7,1.7,0,0,0,.747-.731,1.7,1.7,0,0,1-.747.731L47.249-38.92l-.075.042m0-.115-3.31-3.256,3.31-3.256,4,2.233a1.473,1.473,0,0,1,.84,1.023v0a1.473,1.473,0,0,1-.84,1.022l-4,2.233",
    transform: "translate(-43.864 45.506)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -3.237,
    y1: 4.059,
    x2: -3.227,
    y2: 4.059,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.018-29.862a1.042,1.042,0,0,1-.708-.256h0a1.043,1.043,0,0,0,.708.256l.073,0-.074,0m0-.115a1.04,1.04,0,0,1-.708-.256h0L37.238-40l3.31,3.256h0l-11.632,6.5a1.868,1.868,0,0,1-.9.264m-.711-.143c-.018-.016-.035-.032-.052-.05l.052.05",
    transform: "translate(-27.256 39.999)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1.232,
    y1: 2.333,
    x2: -1.226,
    y2: 2.333,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.273-47.009h0l-9.929-9.766a1.042,1.042,0,0,1,.707-.256,1.872,1.872,0,0,1,.9.265l11.631,6.5-3.31,3.256m3.384-3.329L28.952-56.881a1.871,1.871,0,0,0-.9-.265h0a1.867,1.867,0,0,1,.9.265l11.706,6.543M28.046-57.146h0",
    transform: "translate(-27.345 57.146)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -1.234,
    y1: 3.333,
    x2: -1.228,
    y2: 3.333,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.37-34.324h0l.075-.042-.075.042",
    transform: "translate(-49.37 34.367)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -393.081,
    y1: 481.772,
    x2: -392.02,
    y2: 481.772,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#cc9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#cc8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc7d00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.015-27.61a1.043,1.043,0,0,1-.708-.256h0l0,0-.052-.05-.005-.005.06-.059a1.04,1.04,0,0,0,.708.256,1.868,1.868,0,0,0,.9-.264l11.632-6.5.075.073-.075.042-11.631,6.5a1.938,1.938,0,0,1-.824.263l-.073,0",
    transform: "translate(-27.247 34.491)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -1.225,
    y1: 2.963,
    x2: -1.219,
    y2: 2.963,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc2e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0e4e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27-24.226h0a1.562,1.562,0,0,1-.371-1.108v-.115A1.562,1.562,0,0,0,27-24.341l.06.056-.06.059",
    transform: "translate(-26.63 25.449)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -37.186,
    y1: 12.308,
    x2: -37,
    y2: 12.308,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00a7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00b8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00c4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.247-23.422h0l.06-.059h0l-.06.059",
    transform: "translate(-27.247 23.481)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -275.042,
    y1: 236.065,
    x2: -273.696,
    y2: 236.065,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0333c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab0f56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.446-36.668h0l-.075-.073,4-2.233A1.473,1.473,0,0,0,54.207-40a.963.963,0,0,1-.093.406,1.705,1.705,0,0,1-.747.731l-3.921,2.191",
    transform: "translate(-49.372 39.997)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -6.137,
    y1: 7.104,
    x2: -6.12,
    y2: 7.104,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0c500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#e0a600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#e09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.207-42.3a1.473,1.473,0,0,0-.84-1.023l-4-2.233.075-.073h0l3.921,2.191a1.385,1.385,0,0,1,.84,1.137",
    transform: "translate(-49.371 45.63)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -6.136,
    y1: 8.104,
    x2: -6.12,
    y2: 8.104,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffce40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#ffbc40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb540"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.63-55.433v-.119h0c0-.043,0-.086,0-.127v0a0,0,0,0,1,0,0v0h0A1.488,1.488,0,0,1,27-56.656h0l.059.058a1.509,1.509,0,0,0-.429,1.165m.428-1.278,0,0,0,0",
    transform: "translate(-26.63 56.713)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -37.214,
    y1: 26.187,
    x2: -37.027,
    y2: 26.187,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40b8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40eaff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.544-50.265l-11.631-6.5a1.872,1.872,0,0,0-.9-.265,1.042,1.042,0,0,0-.707.256l-.059-.058h0c.019-.019.037-.038.057-.055l0,0a1.041,1.041,0,0,1,.7-.256h.006a1.871,1.871,0,0,1,.9.265l11.706,6.542h0l-.075.073",
    transform: "translate(-27.247 57.146)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -1.225,
    y1: 4.91,
    x2: -1.219,
    y2: 4.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65b895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#62bd95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50db97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ed98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40f498"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.509-32.666H17.34a4.146,4.146,0,0,1-4.007-4.25v-25.5a4.146,4.146,0,0,1,4.007-4.25H117.509a4.146,4.146,0,0,1,4.007,4.25v25.5a4.146,4.146,0,0,1-4.007,4.25",
    transform: "translate(-13.333 66.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.509-66.666H17.34a3.986,3.986,0,0,0-4.007,3.941v23.647a3.986,3.986,0,0,0,4.007,3.941H117.509a3.986,3.986,0,0,0,4.007-3.941V-62.725a3.986,3.986,0,0,0-4.007-3.941m0,.631a3.342,3.342,0,0,1,3.366,3.311v23.647a3.342,3.342,0,0,1-3.366,3.311H17.34a3.343,3.343,0,0,1-3.366-3.311V-62.725a3.343,3.343,0,0,1,3.366-3.311H117.509",
    transform: "translate(-13.333 66.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.33-54.85a2.115,2.115,0,0,1-.6,1.579,2.351,2.351,0,0,1-1.766.7,2.439,2.439,0,0,1-1.769-.71,2.358,2.358,0,0,1-.729-1.76A2.358,2.358,0,0,1,69.2-56.8a2.44,2.44,0,0,1,1.769-.71,2.515,2.515,0,0,1,.987.2,1.982,1.982,0,0,1,.752.528l-.423.416a1.635,1.635,0,0,0-1.316-.561,1.844,1.844,0,0,0-1.313.525,1.8,1.8,0,0,0-.554,1.364,1.8,1.8,0,0,0,.554,1.364,1.844,1.844,0,0,0,1.313.525,1.839,1.839,0,0,0,1.343-.528,1.475,1.475,0,0,0,.4-.958H70.967v-.568H73.3a1.986,1.986,0,0,1,.034.357",
    transform: "translate(-35.332 62.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.277-54.9H73.2a2.036,2.036,0,0,1-.574,1.523h0a2.27,2.27,0,0,1-1.709.676,2.359,2.359,0,0,1-1.713-.687,2.281,2.281,0,0,1-.7-1.7,2.279,2.279,0,0,1,.7-1.7,2.358,2.358,0,0,1,1.713-.688,2.435,2.435,0,0,1,.955.192,1.9,1.9,0,0,1,.722.507l.061-.051L72.6-56.9l-.423.416.057.055.062-.05a1.719,1.719,0,0,0-1.378-.589,1.925,1.925,0,0,0-1.369.547,1.874,1.874,0,0,0-.579,1.421,1.874,1.874,0,0,0,.579,1.421,1.925,1.925,0,0,0,1.369.547,1.919,1.919,0,0,0,1.4-.551h0a1.555,1.555,0,0,0,.426-1.007l.007-.086H70.994v-.41h2.25v-.079l-.079.014a1.891,1.891,0,0,1,.032.343h.16a2.051,2.051,0,0,0-.035-.371l-.012-.065H70.834v.726H72.66v-.079l-.08-.007a1.4,1.4,0,0,1-.38.909h0a1.757,1.757,0,0,1-1.286.5,1.761,1.761,0,0,1-1.257-.5,1.716,1.716,0,0,1-.53-1.307,1.716,1.716,0,0,1,.53-1.307,1.761,1.761,0,0,1,1.257-.5,1.554,1.554,0,0,1,1.255.533l.056.066.484-.477.052-.051-.047-.055a2.058,2.058,0,0,0-.782-.55,2.6,2.6,0,0,0-1.019-.2,2.523,2.523,0,0,0-1.826.733,2.438,2.438,0,0,0-.752,1.816,2.439,2.439,0,0,0,.752,1.817,2.522,2.522,0,0,0,1.826.733,2.435,2.435,0,0,0,1.824-.724l-.058-.054.057.056a2.194,2.194,0,0,0,.62-1.634h-.08",
    transform: "translate(-35.279 62.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80.84-56.752H78.65v1.5h1.975v.568H78.65v1.5h2.19v.581H78.033v-4.729H80.84v.581",
    transform: "translate(-39.148 62.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80.787-56.807v-.079h-2.27v1.657h1.975v.41H78.517v1.657h2.19v.423H78.06v-4.572h2.647v.5h.08v0h.08v-.66H77.9v4.887h2.967v-.739h-2.19V-54.66h1.975v-.726H78.677v-1.342h2.19v-.079h-.08",
    transform: "translate(-39.095 62.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.736-52.6h-.618v-4.148H83.775v-.581h3.3v.581H85.736V-52.6",
    transform: "translate(-41.439 62.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.683-52.658v-.079h-.538v-4.148H83.8v-.423h3.144v.423H85.6v4.227h.08v0h.08v-4.07h1.343v-.739H83.642v.739h1.343v4.148h.779v-.079h-.08",
    transform: "translate(-41.386 62.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.25-52.6v-4.729h.618V-52.6H93.25",
    transform: "translate(-45.219 62.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.2-52.658h.08v-4.651h.457v4.572H93.2v.079h0v.079h.7v-4.887h-.778v4.887h.08v-.079",
    transform: "translate(-45.166 62.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.536-52.6h-.618v-4.148H95.575v-.581h3.3v.581H97.536V-52.6",
    transform: "translate(-46.147 62.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.483-52.658v-.079h-.538v-4.148H95.6v-.423h3.144v.423H97.4v4.227h.08v0h.08v-4.07h1.343v-.739H95.441v.739h1.343v4.148h.779v-.079h-.08",
    transform: "translate(-46.093 62.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.6-53.684a1.78,1.78,0,0,0,1.306.531,1.779,1.779,0,0,0,1.306-.531,1.835,1.835,0,0,0,.535-1.358,1.835,1.835,0,0,0-.535-1.358,1.779,1.779,0,0,0-1.306-.531,1.78,1.78,0,0,0-1.306.531,1.837,1.837,0,0,0-.534,1.358A1.837,1.837,0,0,0,105.6-53.684Zm3.069.4a2.379,2.379,0,0,1-1.763.717,2.375,2.375,0,0,1-1.762-.717,2.4,2.4,0,0,1-.708-1.754,2.4,2.4,0,0,1,.708-1.754,2.375,2.375,0,0,1,1.762-.717,2.377,2.377,0,0,1,1.76.72,2.4,2.4,0,0,1,.712,1.75,2.4,2.4,0,0,1-.708,1.754",
    transform: "translate(-49.682 62.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.546-53.739l-.057.055a1.862,1.862,0,0,0,1.363.555,1.861,1.861,0,0,0,1.363-.555,1.915,1.915,0,0,0,.558-1.413,1.915,1.915,0,0,0-.558-1.413h0a1.861,1.861,0,0,0-1.363-.555,1.862,1.862,0,0,0-1.363.555h0a1.916,1.916,0,0,0-.557,1.413,1.916,1.916,0,0,0,.557,1.413l.057-.055.057-.055a1.758,1.758,0,0,1-.511-1.3,1.758,1.758,0,0,1,.511-1.3h0a1.7,1.7,0,0,1,1.249-.508,1.7,1.7,0,0,1,1.249.508h0a1.756,1.756,0,0,1,.511,1.3,1.756,1.756,0,0,1-.511,1.3,1.7,1.7,0,0,1-1.249.508,1.7,1.7,0,0,1-1.249-.508Zm3.069.4-.057-.055a2.3,2.3,0,0,1-1.706.693,2.3,2.3,0,0,1-1.705-.693l0,0,0,0a2.319,2.319,0,0,1-.685-1.7,2.319,2.319,0,0,1,.685-1.7h0a2.3,2.3,0,0,1,1.705-.693,2.3,2.3,0,0,1,1.7.7,2.319,2.319,0,0,1,.689,1.7,2.323,2.323,0,0,1-.686,1.7l.057.055.058.055A2.481,2.481,0,0,0,109.4-55.1a2.478,2.478,0,0,0-.734-1.805,2.458,2.458,0,0,0-1.817-.744,2.458,2.458,0,0,0-1.82.741h0A2.478,2.478,0,0,0,104.3-55.1a2.478,2.478,0,0,0,.731,1.809l0,0,0,0a2.459,2.459,0,0,0,1.82.741,2.462,2.462,0,0,0,1.821-.741l-.058-.055",
    transform: "translate(-49.628 62.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M114.1-52.6v-4.729h.752l2.337,3.679h.027l-.027-.911v-2.768h.618V-52.6h-.645l-2.445-3.857h-.027l.027.912V-52.6H114.1",
    transform: "translate(-53.538 62.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M114.047-52.658h.08v-4.651h.627l2.337,3.679h.153l-.029-.991v-2.688h.458v4.572h-.52l-2.445-3.857h-.153l.029.992v2.866h-.537v.079h0v.079h.7v-3.026l-.027-.913-.08,0v.079h.027v-.079l-.068.042,2.468,3.894h.769v-4.887h-.779v2.848l.027.913.08,0v-.079h-.027v.079l.068-.042-2.36-3.716h-.876v4.887h.08v-.079",
    transform: "translate(-53.485 62.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.86-33.727h1.5v-9.854h-1.5Zm13.468-6.3-1.714,4.272h-.051l-1.779-4.272h-1.611l2.668,5.971-1.521,3.321h1.56l4.111-9.293Zm-8.48,5.185c-.49,0-1.173-.241-1.173-.837,0-.761.851-1.052,1.585-1.052a2.7,2.7,0,0,1,1.366.33,1.8,1.8,0,0,1-1.778,1.559Zm.18-5.4a2.816,2.816,0,0,0-2.668,1.509l1.327.545a1.423,1.423,0,0,1,1.366-.723,1.433,1.433,0,0,1,1.572,1.268v.1a3.35,3.35,0,0,0-1.559-.38c-1.43,0-2.887.773-2.887,2.218a2.3,2.3,0,0,0,2.487,2.168,2.12,2.12,0,0,0,1.908-.963h.051v.76h1.443v-3.778a2.73,2.73,0,0,0-3.041-2.726Zm-9.241,1.415h-2.127v-3.378h2.127a1.721,1.721,0,0,1,1.753,1.689A1.731,1.731,0,0,1,116.787-38.832Zm-.038-4.749h-3.583v9.854h1.495V-37.46h2.088a3.153,3.153,0,0,0,3.286-3.06A3.153,3.153,0,0,0,116.749-43.581ZM97.211-34.844a1.938,1.938,0,0,1-1.9-2.019,1.953,1.953,0,0,1,1.9-2.044,1.9,1.9,0,0,1,1.82,2.044A1.886,1.886,0,0,1,97.211-34.844Zm1.717-4.635h-.052a2.38,2.38,0,0,0-1.795-.749,3.36,3.36,0,0,0-3.266,3.365,3.346,3.346,0,0,0,3.266,3.34,2.341,2.341,0,0,0,1.795-.762h.052v.482a1.729,1.729,0,0,1-1.82,1.968,1.884,1.884,0,0,1-1.717-1.194l-1.3.533a3.247,3.247,0,0,0,3.021,1.981c1.756,0,3.24-1.016,3.24-3.492v-6.019h-1.42Zm2.453,5.753h1.5v-9.854h-1.5Zm3.705-3.251a1.852,1.852,0,0,1,1.781-1.956,1.322,1.322,0,0,1,1.265.711Zm4.648-1.117a3.158,3.158,0,0,0-2.918-2.133,3.21,3.21,0,0,0-3.214,3.352,3.308,3.308,0,0,0,3.382,3.352,3.4,3.4,0,0,0,2.841-1.486l-1.162-.762a1.953,1.953,0,0,1-1.679.927,1.737,1.737,0,0,1-1.652-1.016l4.557-1.854ZM73.426-39.2v1.422h3.46a2.945,2.945,0,0,1-.788,1.79,3.57,3.57,0,0,1-2.672,1.041,3.765,3.765,0,0,1-3.8-3.784,3.765,3.765,0,0,1,3.8-3.784A3.719,3.719,0,0,1,76.034-41.5l1.02-1a5.086,5.086,0,0,0-3.628-1.435,5.325,5.325,0,0,0-5.371,5.207,5.325,5.325,0,0,0,5.371,5.206,4.879,4.879,0,0,0,3.692-1.46,4.654,4.654,0,0,0,1.252-3.327,4.542,4.542,0,0,0-.078-.889ZM82.3-34.844a1.954,1.954,0,0,1-1.924-2.032A1.946,1.946,0,0,1,82.3-38.908a1.946,1.946,0,0,1,1.923,2.032A1.954,1.954,0,0,1,82.3-34.844Zm0-5.384a3.333,3.333,0,0,0-3.421,3.352A3.341,3.341,0,0,0,82.3-33.524a3.341,3.341,0,0,0,3.421-3.352A3.333,3.333,0,0,0,82.3-40.229Zm7.463,5.384a1.954,1.954,0,0,1-1.924-2.032,1.946,1.946,0,0,1,1.924-2.032,1.946,1.946,0,0,1,1.924,2.032A1.954,1.954,0,0,1,89.767-34.844Zm0-5.384a3.333,3.333,0,0,0-3.421,3.352,3.34,3.34,0,0,0,3.421,3.352,3.341,3.341,0,0,0,3.421-3.352,3.333,3.333,0,0,0-3.421-3.352",
    transform: "translate(-35.167 57.374)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.992 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M27.061-36.987,27-37.043a1.562,1.562,0,0,1-.371-1.108v.115h0V-55.353a1.509,1.509,0,0,1,.429-1.165l9.929,9.766-9.928,9.765m-.43-18.486c0-.043,0-.086,0-.127,0,.041,0,.084,0,.127m0-.129a0,0,0,0,1,0,0,0,0,0,0,0,0,0m0-.006h0",
    transform: "translate(-26.63 56.518)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.35 12.51)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M47.173-38.878h0l.075-.042,3.921-2.191a1.7,1.7,0,0,0,.747-.731,1.7,1.7,0,0,1-.747.731L47.249-38.92l-.075.042m0-.115-3.31-3.256,3.31-3.256,4,2.233a1.473,1.473,0,0,1,.84,1.023v0a1.473,1.473,0,0,1-.84,1.022l-4,2.233",
    transform: "translate(-43.864 45.506)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.368 15.765)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M28.018-29.862a1.042,1.042,0,0,1-.708-.256h0a1.043,1.043,0,0,0,.708.256l.073,0-.074,0m0-.115a1.04,1.04,0,0,1-.708-.256h0L37.238-40l3.31,3.256h0l-11.632,6.5a1.868,1.868,0,0,1-.9.264m-.711-.143c-.018-.016-.035-.032-.052-.05l.052.05",
    transform: "translate(-27.256 39.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.421 5.629)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M37.273-47.009h0l-9.929-9.766a1.042,1.042,0,0,1,.707-.256,1.872,1.872,0,0,1,.9.265l11.631,6.5-3.31,3.256m3.384-3.329L28.952-56.881a1.871,1.871,0,0,0-.9-.265h0a1.867,1.867,0,0,1,.9.265l11.706,6.543M28.046-57.146h0",
    transform: "translate(-27.345 57.146)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M28.088-27.532a1.938,1.938,0,0,0,.824-.263l11.631-6.5h0l-11.631,6.5a1.933,1.933,0,0,1-.824.263m-.782-.254,0,0,0,0h0m-.054-.052-.005,0h0l.005.005",
    transform: "translate(-18.885 53.433)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.659 19.095)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M49.37-34.324h0l.075-.042-.075.042",
    transform: "translate(-49.37 34.367)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.362 19.022)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M28.015-27.61a1.043,1.043,0,0,1-.708-.256h0l0,0-.052-.05-.005-.005.06-.059a1.04,1.04,0,0,0,.708.256,1.868,1.868,0,0,0,.9-.264l11.632-6.5.075.073-.075.042-11.631,6.5a1.938,1.938,0,0,1-.824.263l-.073,0",
    transform: "translate(-27.247 34.491)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M27-24.147a1.562,1.562,0,0,1-.371-1.108h0A1.562,1.562,0,0,0,27-24.147h0",
    transform: "translate(-18.639 49.737)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.992 24.367)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M27-24.226h0a1.562,1.562,0,0,1-.371-1.108v-.115A1.562,1.562,0,0,0,27-24.341l.06.056-.06.059",
    transform: "translate(-26.63 25.449)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.362 25.531)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M27.247-23.422h0l.06-.059h0l-.06.059",
    transform: "translate(-27.247 23.481)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.263-39.591A.962.962,0,0,0,57.356-40h0a.965.965,0,0,1-.093.407",
    transform: "translate(-30.861 55.764)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.66 15.767)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M49.446-36.668h0l-.075-.073,4-2.233A1.473,1.473,0,0,0,54.207-40a.963.963,0,0,1-.093.406,1.705,1.705,0,0,1-.747.731l-3.921,2.191",
    transform: "translate(-49.372 39.997)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M54.256-42.3h0a1.385,1.385,0,0,0-.84-1.137L49.5-45.63h0l3.921,2.191a1.382,1.382,0,0,1,.84,1.138",
    transform: "translate(-27.761 58.067)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.659 12.436)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "v"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M54.207-42.3a1.473,1.473,0,0,0-.84-1.023l-4-2.233.075-.073h0l3.921,2.191a1.385,1.385,0,0,1,.84,1.137",
    transform: "translate(-49.371 45.63)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M26.63-55.729h0m0-.128v0m0,0v0m0,0c.046-.81.494-1.278,1.127-1.28a1.041,1.041,0,0,0-.7.256h0l0,0c-.02.017-.038.036-.057.055h0a1.488,1.488,0,0,0-.367.967",
    transform: "translate(-18.639 62.774)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.992 5.884)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "x"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M26.63-55.433v-.119h0c0-.043,0-.086,0-.127v0a0,0,0,0,1,0,0v0h0A1.488,1.488,0,0,1,27-56.656h0l.059.058a1.509,1.509,0,0,0-.429,1.165m.428-1.278,0,0,0,0",
    transform: "translate(-26.63 56.713)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M28.512-57.146h0",
    transform: "translate(-19.389 62.774)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.362 5.629)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M40.544-50.265l-11.631-6.5a1.872,1.872,0,0,0-.9-.265,1.042,1.042,0,0,0-.707.256l-.059-.058h0c.019-.019.037-.038.057-.055l0,0a1.041,1.041,0,0,1,.7-.256h.006a1.871,1.871,0,0,1,.9.265l11.706,6.542h0l-.075.073",
    transform: "translate(-27.247 57.146)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/googlePlayStore.bb9438535affc9b68d39be4108bf6264.svg";
export { ForwardRef as ReactComponent };